// extracted by mini-css-extract-plugin
module.exports = {"purchasedForText":"az_-Kd"};